import React from 'react';
import { Helmet } from "react-helmet";

function About() {
  const teamMembers = [
    {
      id: 1,
      name: 'Δημήτρης Παπαδόπουλος',
      position: 'Ιδρυτής και Κύριος Barber',
      bio: 'Με πάνω από 20 χρόνια εμπειρίας στην τέχνη του barbering, ο Δημήτρης είναι το όραμα πίσω από το Fapugo. Εκπαιδευμένος στα καλύτερα barbershops της Ευρώπης, φέρνει την κλασική τεχνική στη σύγχρονη εποχή.',
      image: '/images/team_1.jpg'
    },
    {
      id: 2,
      name: 'Νίκος Γεωργίου',
      position: 'Senior Barber Specialist',
      bio: 'Ειδικός στα κλασικά κουρέματα και την τέχνη του ξυρίσματος με ξυράφι. Ο Νίκος έχει κερδίσει πολλαπλά βραβεία σε διαγωνισμούς barbering και είναι γνωστός για την προσοχή στη λεπτομέρεια.',
      image: '/images/team_2.jpg'
    },
    {
      id: 3,
      name: 'Μαρία Κωνσταντίνου',
      position: 'Hair Styling Expert',
      bio: 'Η Μαρία φέρνει μια φρέσκια προοπτική στο ανδρικό styling. Με εξειδίκευση στα σύγχρονα trends και τη χρήση προϊόντων περιποίησης, βοηθά τους πελάτες να βρουν το τέλειο στυλ.',
      image: '/images/team_3.jpg'
    },
    {
      id: 4,
      name: 'Κώστας Ανδρέου',
      position: 'Grooming Consultant',
      bio: 'Ειδικός στην περιποίηση γενειάδας και στα ανδρικά προϊόντα grooming. Ο Κώστας παρέχει εξατομικευμένες συμβουλές για κάθε τύπο μαλλιών και δέρματος, βοηθώντας τους πελάτες να επιτύχουν τα καλύτερα αποτελέσματα.',
      image: '/images/team_4.jpg'
    },
    {
      id: 5,
      name: 'Γιάννης Μιχαηλίδης',
      position: 'Master Barber Instructor',
      bio: 'Με πάθος για την εκπαίδευση, ο Γιάννης μοιράζεται τις γνώσεις του με την επόμενη γενιά barbers. Είναι πιστοποιημένος εκπαιδευτής και έχει διδάξει σε πολλές ακαδημίες barbering σε όλη την Ελλάδα.',
      image: '/images/team_5.jpg'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Fapugo Barbershop - Επαγγελματικό Κουρείο και Περιποίηση</title>
        <meta name="description" content="Fapugo Barbershop - Επαγγελματικές υπηρεσίες κουρέματος και περιποίησης. Ανακαλύψτε τις τελευταίες τάσεις στο ανδρικό στυλ και grooming." />
      </Helmet>

      <div className="about-container">
      <div className="about-hero">
        <h1 className="about-title">Σχετικά με το Fapugo Barbershop</h1>
        <p className="about-description">
          Το Fapugo Barbershop ιδρύθηκε το 2009 με ένα απλό όραμα: να προσφέρει την καλύτερη εμπειρία 
          ανδρικής περιποίησης στην Ελλάδα. Συνδυάζοντας παραδοσιακές τεχνικές barbering με σύγχρονες 
          τάσεις στυλ, δημιουργήσαμε ένα χώρο όπου κάθε άνδρας μπορεί να εκφράσει την προσωπικότητά του 
          μέσα από την εμφάνισή του. Η φιλοσοφία μας είναι απλή: κάθε κούρεμα είναι μια τέχνη, κάθε πελάτης 
          είναι μοναδικός, και η ποιότητα δεν είναι προαιρετική.
        </p>
      </div>

      <section className="team-section">
        <h2 className="team-title">Η Ομάδα μας</h2>
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-card">
              <img 
                src={member.image} 
                alt={member.name} 
                className="team-image"
                width="400"
                height="400"
              />
              <div className="team-info">
                <h3 className="team-name">{member.name}</h3>
                <p className="team-position">{member.position}</p>
                <p className="team-bio">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="about-blog-section">
        <h2 className="about-blog-title">Η Ιστορία μας</h2>
        <div className="about-blog-content">
          <p>
            Το ταξίδι του Fapugo Barbershop ξεκίνησε το 2009, όταν ο ιδρυτής μας, Δημήτρης Παπαδόπουλος, 
            επέστρεψε στην Ελλάδα μετά από χρόνια εκπαίδευσης στα πιο διάσημα barbershops της Ευρώπης. 
            Με όραμα να φέρει την αυθεντική barbershop εμπειρία στη χώρα μας, άνοιξε το πρώτο κατάστημα 
            στο κέντρο του Μαλεβιζίου.
          </p>
          <p>
            Από την πρώτη μέρα, επικεντρωθήκαμε στην ποιότητα και την προσωπική εξυπηρέτηση. Κάθε μέλος 
            της ομάδας μας επιλέγεται προσεκτικά και εκπαιδεύεται σε παραδοσιακές τεχνικές και σύγχρονες 
            μεθόδους. Πιστεύουμε ότι το barbering δεν είναι απλώς μια δουλειά, αλλά μια τέχνη που απαιτεί 
            πάθος, αφοσίωση και συνεχή εκπαίδευση.
          </p>
          <p>
            Σήμερα, με πάνω από 15 χρόνια λειτουργίας, το Fapugo Barbershop έχει εξυπηρετήσει χιλιάδες 
            πελάτες και έχει γίνει συνώνυμο της ποιότητας στην ανδρική περιποίηση. Το blog μας δημιουργήθηκε 
            για να μοιραστούμε τις γνώσεις και την εμπειρία μας με ένα ευρύτερο κοινό, βοηθώντας κάθε άνδρα 
            να φροντίζει την εμφάνισή του με επαγγελματικό τρόπο.
          </p>
        </div>
      </section>
    </div>
  
    </>);
}

export default About;